import React from "react";
import FilterList from "../../../components/user/workingPart/workingPartFilterList";
import Layout from "../../../components/layouts/verticalLayout";

const WorkingPartTechnicalListPage = (props) => {
  return <Layout body={<FilterList isTechnical />} />;
};

WorkingPartTechnicalListPage.propTypes = {};

export default WorkingPartTechnicalListPage;
